module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-9802e7640dd1e0dc7ac843a972a70a63.svg";